import { CloudWorkloadSecurityCustomerViewDataProviderFactory } from '../factory/CloudWorkloadSecurityCustomerViewDataProviderFactory';
import { CloudWorkloadSecurityCustomerViewDataProvider } from '../dataProvider/CloudWorkloadSecurityCustomerViewDataProvider';
import { CloudWorkloadSecurityCompanyRecord } from '../types';
import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';

export class CloudWorkloadSecurityCustomerViewRepository extends BaseWebComponentRepository {
  public dataProviderFactory: CloudWorkloadSecurityCustomerViewDataProviderFactory;
  public dataProvider: CloudWorkloadSecurityCustomerViewDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new CloudWorkloadSecurityCustomerViewDataProviderFactory(),
    });
  }

  public async getCompany(): Promise<CloudWorkloadSecurityCompanyRecord | undefined> {
    return this.dataProvider.getCompany();
  }

  public async createAccount(companyId: string): Promise<{ success: boolean }> {
    return this.dataProvider.createAccount(companyId);
  }
}
